import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'displayName',
    standalone: false
})
export class DisplayNamePipe implements PipeTransform {

  transform(sender: any, receiver: any, fallback?: any): string {
    let userName = ''
    if (sender) {
      userName =sender.name || '';
    } else if (receiver) {
      userName =receiver.name || '';
    } else if (fallback) {
      userName = fallback;
    }
    return userName ? contentSplice(userName, 4) : '-';
  }
}

function contentSplice(name: string, position: number = 0) {
  return name.length >= 30 ? `${name.slice(0, position)}...${name.slice(name.length - position)}` : name
}
